import React, { Component } from "react";
import CustomButton from "../../../../components/inputs/button";
import TextField from "../../../../components/inputs/textfield";
import Snackbar from "../../../../components/snackbar/snackbar";
import { admin_exp_resume_update } from "../../admin.api";
import "./dialog.css";

class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      formData: props.formData,
      edit: props.edit,
      submitted: false,
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    };
  }

  componentWillReceiveProps = (props) => {
    this.setState({
      open: props.open,
      edit: props.edit,
      formData: props.formData,
    });
  };

  // handle file change
  handleChange = (e) => {
    const file = e.target.files[0];
    const name = e.target.name;

    this.setState({ formData: { ...this.state.formData, [name]: file } }, () =>
      console.log("Updated FormData:", this.state.formData)
    );
  };

  // close snackbar
  snackbarClose = () => {
    this.setState({
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    });
    this.props.handleClose();
  };

  // submit resume update
  handleSubmit = (e) => {
    e.preventDefault();
    const { edit, formData } = this.state;
    console.log("FormData before submit:", formData); // 👈 log here

    if (!formData.resume) {
      this.setState({
        submitted: false,
        snackMessage: "Please upload a resume",
        isSnackError: true,
        snackOpen: true,
      });
      return;
    }
    if (!(formData.resume instanceof File)) {
      this.setState({
        submitted: false,
        snackMessage: "Please upload a valid resume file",
        isSnackError: true,
        snackOpen: true,
      });
      return;
    }

    const payload = new FormData();
    payload.append("resume", formData.resume);

    admin_exp_resume_update(payload, formData.id)
      .then((res) => {
        this.setState({
          submitted: true,
          snackMessage: res.message,
          isSnackError: false,
          snackOpen: true,
        });
      })
      .catch((error) => {
        this.setState({
          submitted: false,
          snackMessage: error.message,
          isSnackError: true,
          snackOpen: true,
        });
      });
  };

  render() {
    const { submitted, formData, open, edit } = this.state;

    return (
      <React.Fragment>
        {open && (
          <div className="overlay">
            <div className="big-dia dialog">
              <Snackbar
                message={this.state.snackMessage}
                error={this.state.isSnackError}
                open={this.state.snackOpen}
                close={this.snackbarClose}
              />
              <div className="row">
                <div className="flexDisplay">
                  <div className="diaTitleCon">Edit Resume</div>
                  <div className="dia-close" onClick={this.props.handleClose}>
                    <div className="diaCloseCon">
                      <div className="diaClose">&#10005;</div>
                    </div>
                  </div>
                </div>
                <br />
                <form onSubmit={this.handleSubmit}>
                  <div className="row book-form">
                    <div className="col-12">
                      <TextField
                        id="resume"
                        label="Resume"
                        name="resume"
                        type="file"
                        fileName={
                          formData.resume
                            ? formData.resume.name || formData.resume
                            : "Upload Resume"
                        }
                        accept=".pdf,.doc,.docx"
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    <div className="col-12">
                      <CustomButton
                        label={edit ? "Update" : "Add"}
                        // disabled={submitted}
                        type="submit"
                        onClick={this.handleSubmit}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default Dialog;
